import React from "react"

export default function ProhibitedCountriesSubtitle() {
	return (
		<>
			If a new application is created with any of the prohibitions selected below, the application will be automatically
			denied.
			<br />
			Existing customers with any of the below prohibitions will be unable to open any new account(s).
		</>
	)
}
